export enum EDITOR_VIEW_MODE {
  editor = 'editor',
  pictureView = 'pictureView',
  productEditor = 'productEditor', // use for those product that have more than one layer of editing. See multiphoto
}

export enum ACTIVE_TOOLS {
  frame = 'frame',
  filters = 'filters',
  adjustments = 'adjustments',
  replace = 'replace',
  multiFrame = 'multi-frame',
  orientation = 'orientation',
}

export enum SAVING_STATE {
  toBeSaved = 'to-be-saved',
  saving = 'saving',
  saved = 'saved',
  uploading = 'uploading',
}

export const FINALIZE_ACTIVE_PRODUCT_DELAY = 500;
